import { useState } from "react";
import { sendEmailVerification, getAuth } from "firebase/auth";

export default function ResendVerification() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const auth = getAuth();

  const handleResend = async () => {
    if (!auth.currentUser) return;

    setLoading(true);
    try {
      await sendEmailVerification(auth.currentUser);
      setSent(true);
    } catch (error) {
      console.error("Resend error:", error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="rounded-2xl border border-slate-200 bg-white p-8">
          <div className="text-lg font-semibold text-slate-900 mb-4">
            Resend Verification Email
          </div>

          {sent ? (
            <div className="text-sm text-green-600 mb-4">
              ✅ Verification email sent! Check your inbox.
            </div>
          ) : (
            <div className="text-sm text-slate-600 mb-4">
              Didn't receive the verification email? We can send you another
              one.
            </div>
          )}

          <button
            onClick={handleResend}
            disabled={loading || sent}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-4 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200"
          >
            {loading ? "Sending..." : sent ? "Email Sent!" : "Resend Email"}
          </button>
        </div>
      </div>
    </div>
  );
}
